'use strict';

const Moment = require('moment');
const Pagination = require('framework/domain/value/pagination');
const ReadMoreCollection = require('framework/domain/collection/readmore-collection');

module.exports = class TaskCollection extends ReadMoreCollection {
    constructor(models, options) {
        super(models, options);

        this._repository = options.repository;
    }

    // updatedAt でソートした後、state でソートする
    model2number(model) {
        const time = Moment(model.getUpdatedAt()).unix();

        return - time;
    }

    isBelongToCollection() {
        return true;
    }

    fetch(limit, cursor) {
        return this._repository.fetch(limit, cursor)
            .then(result => {
                const pagination = result.pagination;
                return {
                    models: result.models,
                    pagination: new Pagination(
                        pagination.totalCount,
                        pagination.prevCursor,
                        pagination.prevMore,
                        pagination.nextCursor,
                        pagination.more
                    )
                }
            });
    }
};



// WEBPACK FOOTER //
// ./my/domain/collection/task.js